import {STORE_PAGE_SIZE} from '../format-product-result-summary';

/**
 * 1-based rank of one card in the result set on screen.
 * `acceptedPage` is the 1-based page that produced those cards. Pass the page
 * from the render that drew them. A page the shopper has only requested — still
 * loading, failed, or replaced by a newer request — is not an input, so it
 * cannot move this rank. A missing page is page 1, the same fallback as the
 * result summary.
 */
export function storeGridClickPosition(acceptedPage: number | null, tileIndex: number): number {
    const page = acceptedPage ?? 1;
    return (page - 1) * STORE_PAGE_SIZE + tileIndex + 1;
}
